
import "../node_modules/bootstrap-sass/assets/stylesheets/_bootstrap.scss";
import "../node_modules/font-awesome/scss/font-awesome.scss";



// WEBPACK FOOTER //
// ./src/vendors.js